// Remembers ad-campaign parameters (utm_*, fbclid…) from the first landing URL for the whole visit so a demo booked later still carries them.
const KEY = "buma:utm";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureUtm() {
  try {
    const q = new URLSearchParams(window.location.search);
    const found = Object.fromEntries(FIELDS.filter((k) => q.get(k)).map((k) => [k, q.get(k).slice(0, 120)]));
    if (q.get("fbclid")) found.fbclid = "1";
    if (Object.keys(found).length) {
      found.landing = window.location.pathname.slice(0, 200);
      found.referrer = (document.referrer || "").slice(0, 300);
      sessionStorage.setItem(KEY, JSON.stringify(found));
    } else if (!sessionStorage.getItem(KEY) && document.referrer && !document.referrer.includes(window.location.host)) {
      sessionStorage.setItem(KEY, JSON.stringify({ referrer: document.referrer.slice(0, 300), landing: window.location.pathname.slice(0, 200) }));
    }
  } catch { /* storage unavailable */ }
}

export function getUtm() {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; }
}

// WhatsApp click-to-chat link with a prefilled greeting; the campaign name (or source) is appended so sales knows which ad brought the lead.
export function salesWhatsAppUrl(lang) {
  const n = process.env.REACT_APP_SALES_WHATSAPP;
  if (!n) return null;
  const u = getUtm() || {};
  const camp = u.utm_campaign || u.utm_source || (u.fbclid ? "facebook" : "");
  const base = lang === "ar" ? "مرحباً، أودّ عرضاً توضيحياً لمنصة BUMA لمؤسستي" : "Hi, I'd like a BUMA demo for my institution";
  const tail = camp ? (lang === "ar" ? ` (حملة: ${camp})` : ` (campaign: ${camp})`) : "";
  return `https://wa.me/${n}?text=${encodeURIComponent(base + tail)}`;
}
